export default __webpack_public_path__ + "static/media/grid.007.49db99d1.jpeg";